/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Time period for filtering data. Use 'custom' with startDate and endDate for custom ranges.
 * @export
 */
export const TimeFilter = {
    day: 'day',
    week: 'week',
    month: 'month',
    year: 'year',
    all: 'all',
    custom: 'custom'
} as const;
export type TimeFilter = typeof TimeFilter[keyof typeof TimeFilter];


export function instanceOfTimeFilter(value: any): boolean {
    for (const key in TimeFilter) {
        if (Object.prototype.hasOwnProperty.call(TimeFilter, key)) {
            if (TimeFilter[key as keyof typeof TimeFilter] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TimeFilterFromJSON(json: any): TimeFilter {
    return TimeFilterFromJSONTyped(json, false);
}

export function TimeFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeFilter {
    return json as TimeFilter;
}

export function TimeFilterToJSON(value?: TimeFilter | null): any {
    return value as any;
}

export function TimeFilterToJSONTyped(value: any, ignoreDiscriminator: boolean): TimeFilter {
    return value as TimeFilter;
}

